import { normalizeNetworkLifecycle, type DiagramDocument } from '@ukrop-nm/shared';

function isPlainObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

/** Parse a previously exported diagram.json into the editor (local file only). */
export function parseImportedDiagram(text: string): DiagramDocument {
  let parsed: unknown;
  try {
    parsed = JSON.parse(text);
  } catch {
    throw new Error('Файл не є коректним JSON.');
  }
  if (!isPlainObject(parsed)) {
    throw new Error('Очікувався обʼєкт схеми.');
  }
  if (parsed.schemaVersion !== 1) {
    throw new Error('Підтримується лише schemaVersion = 1.');
  }
  if (!Array.isArray(parsed.nodes) || !Array.isArray(parsed.edges)) {
    throw new Error('У файлі немає масивів nodes / edges.');
  }
  const doc = parsed as unknown as DiagramDocument;
  return {
    ...doc,
    lifecycle: normalizeNetworkLifecycle(doc.lifecycle as string | undefined),
  };
}
